import './Footer.css';

function Footer() {
    const currentYear = new Date().getFullYear();
    return (
        <div className="footer-wrapper">
            <div className="footer-left">
                <span>© 2023 - {currentYear} Mimdinare</span>
            </div>
            <div className="footer-right">
                <div className="footer-developed-by">
                    <span>Crafted By</span>
                    <a
                        title="Crafted by ARTISANS"
                        target="_blank"
                        rel="noopener"
                        href="https://artisans.ge">
                        ARTISANS
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Footer;

